import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=0f1c4a72&scoped=true&"
import script from "./ApproveModal.vue?vue&type=script&lang=js&"
export * from "./ApproveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c4a72",
  null
  
)

export default component.exports